<template>
  <div>
  <DModal :show-close="false" :isBgOverlay="true" :isCloseOnBgClick="false" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal text-dark" slot="insertComponent">
      <div class="d-modal__header">
        <div>
          <h2>Aktive faste tillæg i OPUS</h2>
          <p class="d-modal__subtitle">
            {{ userName }} · {{ employmentLabel }}
          </p>
        </div>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__toolbar d-modal__toolbar--end">
        <button class="do-bttn do-bttn--submit" @click="openCreate" v-if="!isShowCreate">
          Opret fast tillæg
        </button>
      </div>

      <div class="d-modal__content">
        <!-- Inline opret-formular -->
        <div v-if="isShowCreate" class="create-form">
          <h3 class="create-form__title">Nyt fast tillæg</h3>
          <div class="create-form__grid">
            <div class="d-input-group create-form__loenkode">
              <label class="d-label">Lønkode *</label>
              <DSelect
                ref="loenkodeSelect"
                :items="salaryCodesForDSelect"
                :multiple="false"
                :placeholder="'Vælg lønkode'"
                :itemsSelected="selectedSalaryCodeForDSelect"
                :isShowRemoveButton="false"
                @add="onSelectLoenkode"
                @remove="onSelectLoenkode(null)"
              />
            </div>
            <div class="d-input-group create-form__antal">
              <label class="d-label">
                Antal *
                <span class="icon-question3 d-label__help"
                      content="Antal enheder pr. måned, der ganges med satsen for den valgte lønkode. Satsen er defineret i KMD OPUS.<br><br>Eksempel: Hvis satsen for den valgte lønkode er 500 kr., og du angiver 2 enheder, udbetales 1.000 kr. pr. måned."
                      v-tippy="{
                        arrow: true,
                        animateFill: false,
                        animation: 'shift-away',
                        boundary: 'window',
                        placement: 'top',
                        zIndex: 12312312312314
                      }">
                </span>
              </label>
              <input v-model="createForm.antal" type="text" inputmode="decimal" class="d-input width-100"
                     placeholder="Indtast antal"/>
            </div>
            <div class="d-input-group create-form__beloeb">
              <label class="d-label">Beløb</label>
              <input v-model="createForm.beloeb" type="text" inputmode="decimal"
                     class="d-input width-100" placeholder="(valgfri)"/>
            </div>
            <p class="create-form__hint text-explainer">
              Udfyld Antal, Beløb eller begge afhængigt af lønkoden.
            </p>
            <div class="d-input-group create-form__start">
              <label class="d-label">Startdato *</label>
              <DateSelector class="width-100" :date="createForm.startdato" :width100="true"
                            @changed="createForm.startdato = $event"/>
            </div>
            <div class="d-input-group create-form__slut">
              <label class="d-label">Slutdato *</label>
              <DateSelector v-if="!createForm.noEndDate" class="width-100" :date="createForm.stopdato" :width100="true"
                            @changed="createForm.stopdato = $event"/>
              <input v-else type="text" class="d-input width-100" :value="openEndedDateLabel" disabled/>
              <label class="create-form__no-end-date">
                <input type="checkbox" v-model="createForm.noEndDate" @change="onToggleNoEndDate"/>
                <span>Uden slutdato</span>
              </label>
            </div>
            <div class="d-input-group create-form__cost-center">
              <label class="d-label">Afvigende omkostningssted</label>
              <DSelect
                :items="costCentersForDSelect"
                :multiple="false"
                :placeholder="'Vælg afvigende omkostningssted (valgfri)'"
                :itemsSelected="selectedCostCenterForDSelect"
                :isShowRemoveButton="true"
                @add="onSelectCostCenter"
                @remove="onSelectCostCenter(null)"
              />
            </div>
          </div>
          <p v-if="createOverlapWarning" class="text-explainer create-form__warning">
            {{ createOverlapWarning }}
          </p>
          <p v-if="createValidationMessage" class="text-explainer text-explainer--danger">
            {{ createValidationMessage }}
          </p>
          <div class="create-form__actions">
            <button class="do-bttn" @click="closeCreate">Annuller</button>
            <button class="do-bttn do-bttn--submit"
                    :class="{'do-bttn--submit--loading': isCreating, 'do-bttn--submit--disabled': !isCreateValid}"
                    :disabled="!isCreateValid || isCreating"
                    @click="submitCreate">
              Send til OPUS
            </button>
          </div>
        </div>

        <Loader v-if="isLoading" :isLoaderModal="true"></Loader>

        <template v-else>
          <table class="do-table">
            <thead>
            <tr>
              <th class="td-loenkode">LØNKODE</th>
              <th class="td-units">ENHEDER</th>
              <th class="td-units">BELØB</th>
              <th class="td-date">FRA</th>
              <th class="td-date">TIL</th>
              <th>OMK.STED</th>
              <th class="th-actions"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="displayedPayments.length === 0">
              <td :colspan="7" class="italic">
                Ingen faste tillæg i OPUS
              </td>
            </tr>
            <tr v-for="row in displayedPayments" :key="row.id != null ? row.id : row.objekt_id" class="fast-tillaeg-row">
              <td class="td-loenkode">{{ row.vLoenart }}</td>
              <td class="td-units">{{ formatDecimal(row.antal) }}</td>
              <td class="td-units">{{ formatDecimal(row.beloeb) }}</td>
              <td class="td-date">{{ row.vFraDato }}</td>
              <td class="td-date">{{ row.vTilDato }}</td>
              <td>{{ row.afv_omkostningssted || '—' }}</td>
              <td class="td-actions">
                <DDropdown :isBottomStart="false" :isShowDots="false">
                  <button slot="title" class="do-bttn do-bttn--small">
                    Handlinger <span class="icon-arrow-down5"></span>
                  </button>
                  <ul slot="list" class="action-menu">
                    <li @click="openStop(row)">Sæt stopdato</li>
                    <li @click="openExtend(row)">Forlæng</li>
                    <li class="d-item-warning" @click="openDelete(row)">Slet</li>
                  </ul>
                </DDropdown>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </DModal>

    <!-- Stop tillæg (afgræns) -->
    <DModal
      v-if="rowToStop"
      :show-close="false"
      :isBgOverlay="true"
      :isCloseOnBgClick="false"
      @close="closeAction"
      :appendToBody="true"
      style="z-index: 12312312312313"
      :placeInTop="true">
      <div class="d-modal d-modal--small" slot="insertComponent">
        <div class="d-modal__header">
          <h2>Stop fast tillæg</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="closeAction">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__content">
          <p>Tillægget stopper på den valgte dato. Dette kan ikke fortrydes.</p>
          <div class="d-input-group">
            <label class="d-label">Stopdato *</label>
            <DateSelector class="width-100" :date="stopDate" :maxDate="stopMaxDate" :width100="true"
                          @changed="stopDate = $event"/>
          </div>
          <p v-if="actionError" class="text-explainer text-explainer--danger">{{ actionError }}</p>
        </div>
        <div class="d-modal__buttons">
          <div class="d-modal__buttons__child">
            <button class="do-bttn" @click="closeAction">Annuller</button>
            <button class="do-bttn do-bttn--submit"
                    :class="{'do-bttn--submit--loading': isSubmittingAction}"
                    :disabled="isSubmittingAction || !stopDate"
                    @click="submitStop">
              Stop tillæg
            </button>
          </div>
        </div>
      </div>
    </DModal>

    <!-- Forlæng tillæg (opret nyt) -->
    <DModal
      v-if="rowToExtend"
      :show-close="false"
      :isBgOverlay="true"
      :isCloseOnBgClick="false"
      @close="closeAction"
      :appendToBody="true"
      style="z-index: 12312312312313"
      :placeInTop="true">
      <div class="d-modal d-modal--small" slot="insertComponent">
        <div class="d-modal__header">
          <h2>Forlæng fast tillæg</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="closeAction">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__content">
          <p>Der oprettes et nyt tillæg med samme lønart, beløb og bemærkning fra den nuværende stopdato til den nye
            dato.</p>
          <div class="d-input-group">
            <label class="d-label">Ny slutdato *</label>
            <DateSelector class="width-100" :date="extendDate" :minDate="extendMinDate" :width100="true"
                          @changed="extendDate = $event"/>
          </div>
          <p v-if="actionError" class="text-explainer text-explainer--danger">{{ actionError }}</p>
        </div>
        <div class="d-modal__buttons">
          <div class="d-modal__buttons__child">
            <button class="do-bttn" @click="closeAction">Annuller</button>
            <button class="do-bttn do-bttn--submit"
                    :class="{'do-bttn--submit--loading': isSubmittingAction}"
                    :disabled="isSubmittingAction || !extendDate"
                    @click="submitExtend">
              Forlæng tillæg
            </button>
          </div>
        </div>
      </div>
    </DModal>

    <!-- Slet bekræftelse -->
    <DModal
      v-if="rowToDelete"
      :show-close="false"
      :isBgOverlay="true"
      :isCloseOnBgClick="false"
      @close="closeAction"
      :appendToBody="true"
      style="z-index: 12312312312313"
      :placeInTop="true">
      <div class="d-modal d-modal--small" slot="insertComponent">
        <div class="d-modal__header">
          <h2>Slet fast tillæg</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="closeAction">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__content">
          <p>Er du sikker på, at du vil slette dette tillæg helt? Det fjernes fra lønsystemet og kan ikke
            gendannes.</p>
          <p v-if="actionError" class="text-explainer text-explainer--danger">{{ actionError }}</p>
        </div>
        <div class="d-modal__buttons">
          <div class="d-modal__buttons__child">
            <button class="do-bttn" @click="closeAction">Annuller</button>
            <button class="do-bttn do-bttn--submit do-bttn--danger"
                    :class="{'do-bttn--submit--loading': isSubmittingAction}"
                    :disabled="isSubmittingAction"
                    @click="submitDelete">
              Slet tillæg
            </button>
          </div>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import DModal from '../../common/DModal.vue'
import DateSelector from '../../datepicker/DateSelector.vue'
import DSelect from '../../DSelect/DSelect.vue'
import DDropdown from '../../common/DDropdown.vue'
import Loader from '../../common/Loader.vue'
import moment from 'moment'
import eventbus from '../../../eventbus'
import docendo from '../../../docendo'

export default {
  name: 'FasteTillaegModal',
  components: {DModal, DateSelector, DSelect, DDropdown, Loader},
  props: {
    schoolId: {
      type: Number,
      required: true
    },
    employmentId: {
      required: true
    },
    employment: {
      default: null
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      payments: [],
      kmdPayments: [],
      rowToStop: null,
      stopDate: null,
      rowToExtend: null,
      extendDate: null,
      rowToDelete: null,
      actionError: '',
      isSubmittingAction: false,
      isShowCreate: false,
      isCreating: false,
      createValidationMessage: '',
      createForm: {
        salaryCodeId: null,
        antal: '',
        beloeb: '',
        salaryCostCenterId: null,
        startdato: null,
        stopdato: null,
        noEndDate: false
      }
    }
  },
  computed: {
    employmentLabel () {
      const e = this.employment
      if (!e) return ''
      const title = e.source_title || e.title || 'Ansættelse'
      return e.employment_number ? e.employment_number + ' - ' + title : title
    },
    schoolYearStartDate () {
      const year = this.$store.state.localActivatedSchoolYear
      const firstOfNextMonth = moment().add(1, 'month').startOf('month')
      if (year && year.employee_time_start) {
        const start = moment(year.employee_time_start)
        // Hvis skoleårets start allerede er overskredet, brug den første i næste måned.
        return start.isBefore(moment(), 'day') ? firstOfNextMonth : start
      }
      return firstOfNextMonth
    },
    schoolYearEndDate () {
      const year = this.$store.state.localActivatedSchoolYear
      if (year && year.employee_time_end) {
        return moment(year.employee_time_end)
      }
      return moment().add(1, 'year')
    },
    // Stop (afgræns) er en forkortelse: ny stopdato skal ligge FØR den nuværende (og være forskellig),
    // ellers afvises den af OPUS (kode 320). Derfor er max = dagen før nuværende stopdato.
    stopMaxDate () {
      return this.rowToStop && this.rowToStop.stopdato
        ? moment(this.rowToStop.stopdato).subtract(1, 'day')
        : null
    },
    // Forlæng må kun vælge datoer > nuværende stopdato.
    extendMinDate () {
      return this.rowToExtend && this.rowToExtend.stopdato
        ? moment(this.rowToExtend.stopdato).add(1, 'day')
        : null
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted || []
    },
    // Lønkoder slås op på den fulde lønkode (4 cifre = lønart + løbenummer).
    salaryCodesByLoenkode () {
      const map = {}
      for (let i = 0; i < this.salaryCodes.length; i++) {
        const code = this.salaryCodes[i]
        if (code.loenart) map[String(code.loenart)] = code
      }
      return map
    },
    salaryCodesForDSelect () {
      return this.salaryCodes
        .filter(sc => sc.loenart)
        .map(sc => {
          const value = String(sc.loenart)
          const name = sc.name || ''
          return {
            id: sc.id,
            name: value + (name ? ' - ' + name : ''),
            value: value,
            original: sc
          }
        })
    },
    selectedSalaryCodeForDSelect () {
      if (this.createForm.salaryCodeId == null) return []
      const found = this.salaryCodesForDSelect.find(item => item.id === this.createForm.salaryCodeId)
      return found ? [found] : []
    },
    costCenters () {
      return this.$store.getters.costCenters || []
    },
    costCentersForDSelect () {
      return this.costCenters.map(cc => {
        const code = cc.code != null ? String(cc.code) : ''
        const title = cc.title || cc.name || ''
        return {
          id: cc.id,
          name: code + (title ? ' - ' + title : ''),
          value: code,
          original: cc
        }
      })
    },
    selectedCostCenterForDSelect () {
      if (this.createForm.salaryCostCenterId == null) return []
      const found = this.costCentersForDSelect.find(item => item.id === this.createForm.salaryCostCenterId)
      return found ? [found] : []
    },
    displayedPayments () {
      return this.payments.map(item => {
        const loenkode = this.loenkodeForRow(item)
        const salaryCode = loenkode ? this.salaryCodesByLoenkode[loenkode] : null
        const codeName = (salaryCode && salaryCode.name) || item.loenart_tekst || ''
        const vLoenart = codeName
          ? (loenkode ? loenkode + ' - ' + codeName : codeName)
          : (loenkode || '—')
        return {
          ...item,
          vLoenart,
          vFraDato: item.startdato ? moment(item.startdato).format('DD-MM-YYYY') : '',
          vTilDato: item.stopdato ? moment(item.stopdato).format('DD-MM-YYYY') : ''
        }
      })
    },
    isCreateValid () {
      const hasLoenkode = this.createForm.salaryCodeId != null
      const antal = parseFloat(String(this.createForm.antal).replace(',', '.'))
      const hasAntal = !isNaN(antal) && antal > 0 && antal <= 9999
      const hasStart = !!this.createForm.startdato && moment(this.createForm.startdato).isValid()
      const hasStop = !!this.createForm.stopdato && moment(this.createForm.stopdato).isValid()
      const stopAfterStart = hasStart && hasStop && moment(this.createForm.stopdato).isSameOrAfter(moment(this.createForm.startdato))
      return hasLoenkode && hasAntal && hasStart && hasStop && stopAfterStart && this.beloebValid
    },
    // Beløb er valgfrit, men hvis udfyldt: max 99999,99 (jf. KMD's grænse på 8 cifre).
    beloebValid () {
      if (this.createForm.beloeb === '' || this.createForm.beloeb == null) return true
      const beloeb = parseFloat(String(this.createForm.beloeb).replace(',', '.'))
      return !isNaN(beloeb) && Math.abs(beloeb) <= 99999.99
    },
    // "Uden slutdato" sættes til KMD's åbne slutdato (31-12-9999).
    openEndedDateLabel () {
      return moment('9999-12-31').format('DD-MM-YYYY')
    },
    // Den valgte lønkode (4 cifre = lønart + løbenummer).
    selectedLoenkode () {
      const sel = this.selectedSalaryCodeForDSelect
      return sel.length ? String(sel[0].value) : ''
    },
    // Advarer hvis der allerede findes et aktivt tillæg med samme lønkode i en overlappende periode.
    // KMD tillader kun ét tillæg pr. lønart/løbenummer indenfor en overlappende virkningsperiode.
    createOverlapWarning () {
      const loenkode = this.selectedLoenkode
      if (!loenkode || !this.createForm.startdato || !this.createForm.stopdato) return ''
      const newStart = moment(this.createForm.startdato)
      const newStop = moment(this.createForm.stopdato)
      const conflict = this.kmdPayments.find(p => {
        if (this.loenkodeForRow(p) !== loenkode) return false
        if (!p.startdato || !p.stopdato) return false
        return newStart.isSameOrBefore(moment(p.stopdato)) && newStop.isSameOrAfter(moment(p.startdato))
      })
      if (!conflict) return ''
      const fra = conflict.startdato ? moment(conflict.startdato).format('DD-MM-YYYY') : ''
      const til = conflict.stopdato ? moment(conflict.stopdato).format('DD-MM-YYYY') : ''
      return 'Der findes allerede et tillæg med lønkode ' + loenkode + ' i perioden ' + fra + ' – ' + til +
        '. KMD tillader kun ét tillæg pr. lønart/løbenummer i en overlappende periode, så dette vil sandsynligvis blive afvist.'
    }
  },
  methods: {
    formatDecimal (value) {
      if (value == null || value === '') return ''
      return String(value).replace('.', ',')
    },
    onSelectLoenkode (item) {
      this.createForm.salaryCodeId = item ? item.id : null
    },
    onSelectCostCenter (item) {
      this.createForm.salaryCostCenterId = item ? item.id : null
    },
    onToggleNoEndDate () {
      if (this.createForm.noEndDate) {
        this.createForm.stopdato = moment('9999-12-31')
      } else {
        this.createForm.stopdato = this.schoolYearEndDate
      }
    },
    // Rekonstruerer den fulde lønkode (lønart polstret til 3 cifre + løbenummer) for en række.
    loenkodeForRow (item) {
      if (item.loenart == null) return ''
      const loenart = String(item.loenart).padStart(3, '0')
      const loebenummer = item.loebenummer != null ? String(item.loebenummer) : '0'
      return loenart + loebenummer
    },
    openCreate () {
      this.createForm.startdato = this.schoolYearStartDate
      this.createForm.stopdato = this.schoolYearEndDate
      this.createForm.noEndDate = false
      this.isShowCreate = true
      // Sørg for at have de aktive OPUS-tillæg til overlap-tjek, uanset hvilken fane der vises.
      docendo.listRecurringPayments(this.schoolId, this.employmentId, success => {
        this.kmdPayments = Array.isArray(success)
          ? success
          : (success && Array.isArray(success.data) ? success.data : [])
      }, () => {})
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.loenkodeSelect) this.$refs.loenkodeSelect.setFocus()
        }, 100)
      })
    },
    closeCreate () {
      this.isShowCreate = false
      this.createValidationMessage = ''
      this.createForm.salaryCodeId = null
      this.createForm.antal = ''
      this.createForm.beloeb = ''
      this.createForm.salaryCostCenterId = null
      this.createForm.noEndDate = false
    },
    read () {
      this.isLoading = true
      docendo.listRecurringPayments(this.schoolId, this.employmentId, success => {
        const list = Array.isArray(success)
          ? success
          : (success && Array.isArray(success.data) ? success.data : [])
        this.payments = list
        this.kmdPayments = list
        this.isLoading = false
      }, failure => {
        console.log('Kunne ikke hente faste tillæg', failure)
        this.payments = []
        this.isLoading = false
        eventbus.toast = {text: 'Kunne ikke hente faste tillæg', success: false, position: 'bottomLeft'}
      })
    },
    closeAction () {
      this.rowToStop = null
      this.rowToExtend = null
      this.rowToDelete = null
      this.actionError = ''
    },
    // Returnerer en fejlbesked hvis response indeholder en fejlstatus, ellers null.
    errorFromResponse (resp) {
      if (!resp) return null
      const isError = resp.status === 'error' || resp.error === true || resp.success === false || !!resp.error_code
      if (!isError) return null
      const code = resp.code || resp.error_code || resp.status_code
      const message = typeof resp.error === 'string' ? resp.error : (resp.message || '')
      if (String(code) === '138' || /\b138\b/.test(String(message)) || /låst/i.test(String(message))) {
        return 'Læreren er låst i lønsystemet. Vent ca. 15 minutter og prøv igen.'
      }
      return message || 'Noget gik galt. Prøv igen eller kontakt support.'
    },
    openStop (row) {
      this.closeAction()
      this.rowToStop = row
      const isOpenEnded = !row.stopdato || row.stopdato === '9999-12-31'
      const maxDate = isOpenEnded ? null : moment(row.stopdato).subtract(1, 'day')
      let dflt = this.schoolYearEndDate
      if (maxDate && dflt.isAfter(maxDate)) dflt = maxDate
      this.stopDate = dflt
    },
    submitStop () {
      if (!this.rowToStop || this.isSubmittingAction || !this.stopDate) return
      this.actionError = ''
      this.isSubmittingAction = true
      const stopDate = moment(this.stopDate).format('YYYY-MM-DD')
      const row = this.rowToStop
      const startDate = row.startdato ? moment(row.startdato).format('YYYY-MM-DD') : stopDate
      docendo.delimitRecurringPayment(
        this.schoolId,
        this.employmentId,
        row.objekt_id,
        startDate,
        stopDate,
        success => {
          const errorMessage = this.errorFromResponse(success)
          if (errorMessage) {
            this.isSubmittingAction = false
            this.actionError = errorMessage
            return
          }
          this.queuedAction('Stop sendt til behandling. Følg status under "Udbakke".')
        },
        failure => {
          console.log('failure', failure)
          this.isSubmittingAction = false
          this.actionError = 'Noget gik galt. Prøv igen eller kontakt support.'
        }
      )
    },
    openExtend (row) {
      this.closeAction()
      this.rowToExtend = row
      const minDate = moment(row.stopdato).add(1, 'day')
      this.extendDate = this.schoolYearEndDate.isAfter(minDate) ? this.schoolYearEndDate : minDate.clone().add(1, 'year')
    },
    submitExtend () {
      if (!this.rowToExtend || this.isSubmittingAction || !this.extendDate) return
      this.actionError = ''
      const row = this.rowToExtend
      const startdato = moment(row.stopdato).add(1, 'day').format('YYYY-MM-DD')
      const stopdato = moment(this.extendDate).format('YYYY-MM-DD')
      const recurringPayment = {
        startdato,
        stopdato,
        loenart: String(row.loenart != null ? row.loenart : '').trim(),
        loebenummer: row.loebenummer != null ? parseInt(row.loebenummer, 10) : 1
      }
      if (row.antal != null && row.antal !== '') {
        recurringPayment.antal = parseFloat(String(row.antal).replace(',', '.'))
      }
      if (row.beloeb != null && row.beloeb !== '') {
        recurringPayment.beloeb = parseFloat(String(row.beloeb).replace(',', '.'))
      }
      this.isSubmittingAction = true
      docendo.createRecurringPaymentForEmployees(
        this.schoolId,
        [this.employmentId],
        recurringPayment,
        success => {
          const errorMessage = this.errorFromResponse(success)
          if (errorMessage) {
            this.isSubmittingAction = false
            this.actionError = errorMessage
            return
          }
          this.queuedAction('Forlængelse sendt til behandling. Følg status under "Udbakke".')
        },
        failure => {
          console.log('failure', failure)
          this.isSubmittingAction = false
          this.actionError = 'Noget gik galt. Prøv igen eller kontakt support.'
        }
      )
    },
    openDelete (row) {
      this.closeAction()
      this.rowToDelete = row
    },
    submitDelete () {
      if (!this.rowToDelete || this.isSubmittingAction) return
      this.actionError = ''
      this.isSubmittingAction = true
      const row = this.rowToDelete
      const startDate = row.startdato ? moment(row.startdato).format('YYYY-MM-DD') : null
      const stopDate = row.stopdato ? moment(row.stopdato).format('YYYY-MM-DD') : null
      docendo.deleteRecurringPayment(
        this.schoolId,
        this.employmentId,
        row.objekt_id,
        startDate,
        stopDate,
        success => {
          const errorMessage = this.errorFromResponse(success)
          if (errorMessage) {
            this.isSubmittingAction = false
            this.actionError = errorMessage
            return
          }
          this.queuedAction('Sletning sendt til behandling. Følg status under "Udbakke".')
        },
        failure => {
          console.log('failure', failure)
          this.isSubmittingAction = false
          this.actionError = 'Noget gik galt. Prøv igen eller kontakt support.'
        }
      )
    },
    // Operationen er kun kø-lagt – OPUS bekræfter (eller fejler) asynkront. Resultatet (inkl. evt.
    // fejlkode/tekst) vises i den samlede "Udbakke", ikke pr. bruger her i modalen.
    queuedAction (message) {
      this.isSubmittingAction = false
      this.closeAction()
      eventbus.toast = {text: message, success: true, position: 'bottomLeft'}
      this.$emit('changed')
      this.read()
    },
    submitCreate () {
      this.createValidationMessage = ''
      const antalValue = parseFloat(String(this.createForm.antal).replace(',', '.'))
      if (!isNaN(antalValue) && antalValue > 9999) {
        this.createValidationMessage = 'Antal må højst være 9.999'
        return
      }
      if (!this.beloebValid) {
        this.createValidationMessage = 'Beløb må højst være 99.999,99'
        return
      }
      if (!this.isCreateValid) {
        this.createValidationMessage = 'Udfyld lønkode, antal og gyldige datoer'
        return
      }
      // Backenden udleder selv lønart/løbenummer fra salary_code_id og omkostningssted fra salary_cost_center_id.
      this.isCreating = true
      const recurringPayment = {
        startdato: moment(this.createForm.startdato).format('YYYY-MM-DD'),
        stopdato: moment(this.createForm.stopdato).format('YYYY-MM-DD'),
        salary_code_id: this.createForm.salaryCodeId,
        antal: parseFloat(String(this.createForm.antal).replace(',', '.'))
      }
      if (this.createForm.beloeb !== '' && this.createForm.beloeb != null) {
        recurringPayment.beloeb = parseFloat(String(this.createForm.beloeb).replace(',', '.'))
      }
      if (this.createForm.salaryCostCenterId != null) {
        recurringPayment.salary_cost_center_id = this.createForm.salaryCostCenterId
      }

      docendo.createRecurringPaymentForEmployees(
        this.schoolId,
        [this.employmentId],
        recurringPayment,
        success => {
          const errorMessage = this.errorFromResponse(success)
          if (errorMessage) {
            this.isCreating = false
            this.createValidationMessage = errorMessage
            return
          }
          this.isCreating = false
          this.closeCreate()
          eventbus.toast = {text: 'Sendt til behandling. Følg status under "Udbakke".', success: true, position: 'bottomLeft'}
          this.$emit('changed')
          this.read()
        },
        failure => {
          console.log('failure', failure)
          this.isCreating = false
          this.createValidationMessage = 'Noget gik galt. Prøv igen eller kontakt support.'
        }
      )
    }
  },
  mounted () {
    this.$store.dispatch('readSalaryCodes')
    this.$store.dispatch('readCostCenters')
    this.read()
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 900px;
  max-width: calc(100vw - 32px);
  border-radius: 16px;
  position: relative;
}

.d-modal--small {
  width: 460px;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.d-modal__subtitle {
  margin: 0.25rem 0 0;
  font-size: 13px;
  color: #6b7280;
}

.d-modal__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eee;
}

.d-modal__toolbar--end {
  justify-content: flex-end;
}

.d-modal__content {
  padding: 1rem;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #eee;
  margin: 0;
}

.d-modal__buttons__child {
  display: flex;
  gap: 0.5rem;
}

.do-table {
  width: 100%;
  border-collapse: collapse;
}

.do-table thead th {
  text-transform: uppercase;
  font-size: 10px;
  color: #8898aa;
  text-align: left;
  padding: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.do-table tbody td {
  padding: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.do-table tbody tr:hover {
  background-color: aliceblue;
}

.td-date, .td-units {
  width: 100px;
}

.td-units {
  text-align: right;
  width: 90px;
}

.do-table thead th.td-loenkode,
.do-table thead th.td-loebenr,
.do-table thead th.td-units {
  text-align: right;
}

.td-loenkode {
  text-align: right;
}

.td-loebenr {
  width: 80px;
  text-align: right;
}

.th-actions {
  width: 130px;
}

.td-actions {
  width: 130px;
  text-align: right;
  white-space: nowrap;
}

.td-actions .d-dropdown-container {
  display: inline-flex;
  justify-content: flex-end;
}

.action-menu li {
  white-space: nowrap;
}

.do-bttn--small {
  padding: 2px 8px;
  font-size: 11px;
  margin-left: 0.25rem;
}

.do-bttn--danger {
  color: var(--danger);
  border-color: var(--danger);
}

.create-form {
  background: #f9fafb;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.create-form__title {
  margin: 0 0 0.75rem;
  font-size: 14px;
}

.create-form__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

.create-form__loenkode {
  grid-column: 1 / -1;
  grid-row: 1;
}

.create-form__antal {
  grid-column: 1;
  grid-row: 2;
}

.create-form__beloeb {
  grid-column: 2;
  grid-row: 2;
}

.create-form__hint {
  grid-column: 1 / -1;
  grid-row: 3;
  margin: -0.35rem 0 0;
}

.create-form__start {
  grid-column: 1;
  grid-row: 4;
}

.create-form__slut {
  grid-column: 2;
  grid-row: 4;
}

.create-form__cost-center {
  grid-column: 1;
  grid-row: 5;
}

.create-form__no-end-date {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0;
  font-size: 12px;
  cursor: pointer;
}

.create-form__no-end-date input {
  cursor: pointer;
  margin: 0;
}

.d-label__help {
  margin-left: 4px;
  font-size: 12px;
  color: #8898aa;
  cursor: help;
}

.d-label__help:hover {
  color: var(--primary, #468ad7);
}

.create-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.d-input-group .d-input {
  height: 34px;
}

.text-explainer--danger {
  color: var(--danger);
  margin-top: 0.5rem;
}

.create-form__warning {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #fef3c7;
  color: #92400e;
  border-radius: 6px;
  font-size: 12px;
}

.do-pill--small {
  padding: 0 0.5rem;
  font-size: 10px;
  line-height: 18px;
  border-radius: 10px;
}

.outbox-msg {
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.3;
  color: #6b7280;
}

.outbox-msg--error {
  color: #991b1b;
}

.do-pill--yellow {
  background: #fef3c7;
  color: #92400e;
}

.do-pill--green {
  background: #dcfce7;
  color: #166534;
}

.do-pill--red {
  background: #fee2e2;
  color: #991b1b;
}
</style>



// WEBPACK FOOTER //
// FasteTillaegModal.vue?16ff83d2